import React from 'react';
import { initialsOf } from '../utils/text';

const AVATAR_COLORS = ['', 'orange', 'teal'];

// Stacked headliners for the agenda row, capped at 3 with a "+N" on the name.
const SpeakerBlock = ({ speakers = [] }) => {
    if (!speakers.length) return null;

    const shown = speakers.slice(0, 3);
    const first = speakers[0];
    const more = speakers.length > 1 ? ` +${speakers.length - 1}` : '';

    return (
        <div className="speaker-line">
            <span className="avatar-stack">
                {shown.map((s, i) => (
                    <span key={i} className="avatar-wrap">
                        {s.headshot_url ? (
                            <img className="avatar" src={s.headshot_url} alt={s.name} style={{ objectFit: 'cover' }} />
                        ) : (
                            <span className={`avatar ${AVATAR_COLORS[i]}`}>{initialsOf(s.name)}</span>
                        )}
                        {s.flag_url && (
                            <img
                                className="avatar-flag"
                                src={s.flag_url}
                                alt=""
                                aria-hidden="true"
                                title={s.country}
                                onError={(e) => { e.currentTarget.style.display = 'none'; }}
                            />
                        )}
                    </span>
                ))}
            </span>
            <span className="speaker-copy">
                <strong title={first.name}>
                    {first.name}
                    {more}
                </strong>
                {first.headline && <span title={first.headline}>{first.headline}</span>}
                {first.organization && <span title={first.organization}>{first.organization}</span>}
            </span>
        </div>
    );
};

export default SpeakerBlock;
